import { FormInput } from 'components/shared/Forms/ReduxForm'
import { I18n } from 'lib/i18n'
import React from 'react'
import { Field } from 'redux-form'
import { Grid } from 'semantic-ui-react'

const i18nkey = 'admin.discounts.details.'

export default () => (
  <Grid.Row>
    <Grid.Column width={12}>
      <Field
        component={FormInput}
        name="name"
        label={I18n.t(i18nkey + 'name')}
        placeholder={I18n.t(i18nkey + 'name_placeholder')}
        required
      />
    </Grid.Column>
  </Grid.Row>
)



// WEBPACK FOOTER //
// ./src/components/admin/Discounts/DiscountName.jsx